import { SortOrder } from "src/app/shared/types/sort.order";

export class GetFundRangeFundsCommand {
  constructor(
    public page: number = 1,
    public pageSize: number = 25,
    public surveyId: string,
    public fund: string = '',
    public sortBy: string = '',
    public sortOrder: SortOrder) { }
}
